import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { DARKER, PRIMARY } from "../../const/colors";
import ErrorContainer from "./ErrorContainer";
import { countries } from "../../const/countries";
import { useSelector } from "react-redux";
import { selectDetectedCountry } from "../../features/user/userSlice";

const Container = styled.div`
  position: relative;
  flex: 1;
  width: 100%;
  margin: 0.5rem 1rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  > label {
    padding: 0px 1rem;
    font-weight: bold;
    color: white;
    margin: 0.2rem 0px;
  }
  > select {
    border: 1px solid ${PRIMARY};
    outline: none;
    background-color: transparent;
    color: #888;
    padding: 0.7rem 1rem;
    font-size: 1rem;
    width: 100%;
    transition: all 0.3s ease;
  }

  &:hover {
    select {
      border-color: #fff;
    }
  }

  option {
    background-color: ${DARKER};
    color: #fff;
  }
  @media screen and (max-width: 2000px) {
    width: 100%;
    select {
      font-size: 0.9rem;
      margin: 0.2rem 0px;
    }
    label {
      font-size: 0.8rem;
      margin: 0.2rem 0px;
    }
  }

  @media screen and (max-width: 1600px) {
    margin: 0.25rem 1rem;
  }

  @media screen and (max-width: 768px) {
    align-items: center;
    label {
      font-size: 0.9rem;
    }
    select {
      color: white;
      text-align: justify;
      font-weight: bold;
      font-size: 14px;
    }
    margin: 1rem auto;
    text-align: center;
  }

  > select.error {
    border-color: #c21010;
  }
  > select.correct {
    border-color: #28a745;
  }
`;

const CountryBox = ({
  val,
  placeholder,
  label,
  handleChange,
  handleBlur,
  name,
  error,
}) => {
  const [focused, setFocused] = useState(false);
  const [localError, setLocalError] = useState(null);
  const detectedCountry = useSelector(selectDetectedCountry);
  const [country, setCountry] = useState(null);

  const handleFocus = (e) => {
    handleBlur(e);
    setFocused(true);

    if (!e.target.value) {
      setLocalError("Debe seleccionar su país.");
    } else {
      setLocalError(null);
    }
  };

  useEffect(() => {
    const pais = countries.find((x) => x.flag === detectedCountry);
    setCountry(pais);
  }, []);

  return (
    <Container>
      <label>{label}</label>
      <select
        value={val}
        onChange={handleChange}
        onBlur={handleFocus}
        name={name}
        className={
          (localError || error) && focused
            ? "error"
            : !localError && !error && focused
            ? "correct"
            : null
        }
      >
        {country ? (
          <option value={country.flag} key={`${country.code}-${country.lang}`}>
            {country.name}
          </option>
        ) : (
          <>
           <option value={country}>{placeholder}</option>
           {countries.map(country => <option value={country.flag} key={`${country.code}-${country.lang}`}>{country.name}</option>)}
          </>
        )}
       </select>
      {focused && (localError || error) && (
        <ErrorContainer
          focused={focused.toString()}
          error={localError || error}
        />
      )}
    </Container>
  );
};

export default CountryBox;
